// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"196cb05e","462":"196cb05e"}[chunkId] + ".chunk.css";
};